import script from "./header-view.vue?vue&type=script&setup=true&lang=ts"
export * from "./header-view.vue?vue&type=script&setup=true&lang=ts"

import "./header-view.vue?vue&type=style&index=0&id=4d8ff553&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d8ff553"]])

export default __exports__